const { viewportSize } = window.BAO.Utils

let duplicateCount = 0

class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.deduplicateIds()

    this.els?.content?.elements.forEach(contentEl => {
      this.setHidden(
        contentEl,
        contentEl.getAttribute('aria-hidden') === 'true',
      )
    })

    this.openDefault()
  }

  /**
   * @returns {void}
   */
  openDefault () {
    if (this.dataset.openFirstAt !== viewportSize()) return

    const triggerEl = this.els?.trigger?.elements?.[0]
    if (!triggerEl) return

    triggerEl.setAttribute('aria-expanded', true)

    const contentEl = this.els.content.elements.find(
      el => el.id === triggerEl.getAttribute('aria-controls'),
    )
    if (contentEl) this.setHidden(contentEl, false)
  }

  /**
   * The PDP clones its description block into a second column, so an accordion
   * can end up in the document more than once with the same ids. Counting
   * occurrences rather than comparing against getElementById keeps this working
   * whichever copy connects first.
   *
   * @returns {void}
   */
  deduplicateIds () {
    if (!this.els?.content?.exists) return

    this.els.content.elements.forEach(contentEl => {
      const id = contentEl.id
      if (!id || document.querySelectorAll(`[id="${id}"]`).length < 2) return

      const triggerEl = this.querySelector(`[aria-controls="${id}"]`)
      const uniqueId = `${id}-${++duplicateCount}`

      contentEl.id = uniqueId
      triggerEl?.setAttribute('aria-controls', uniqueId)
    })
  }

  /**
   * Collapsed panels stay in the layout so their height can transition, so they
   * need marking inert to keep them out of the tab order while hidden.
   *
   * @param {HTMLElement} contentEl
   * @param {boolean} isHidden
   *
   * @returns {void}
   */
  setHidden (contentEl, isHidden) {
    contentEl.setAttribute('aria-hidden', isHidden)
    contentEl.toggleAttribute('inert', isHidden)
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    if (!this.els?.trigger?.selector) return

    const clickedTriggerEl = event.target.closest(this.els.trigger.selector)
    if (!clickedTriggerEl) return

    const currentState =
      clickedTriggerEl.getAttribute('aria-expanded') === 'true'

    this.els.trigger.elements.forEach(triggerEl => {
      if (triggerEl === clickedTriggerEl) {
        triggerEl.setAttribute('aria-expanded', !currentState)
      } else if (this.dataset.type === 'oneopen') {
        triggerEl.setAttribute('aria-expanded', false)
      }
    })

    this.els.content.elements.forEach(contentEl => {
      if (contentEl.id === clickedTriggerEl.getAttribute('aria-controls')) {
        this.setHidden(contentEl, currentState)
      } else if (this.dataset.type === 'oneopen') {
        this.setHidden(contentEl, true)
      }
    })
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
